import type { paths } from '@luxuryescapes/contract-svc-merchandise'
import requestUtils from 'api/requestUtils'
import qs from 'qs'

type Response = paths['/api/merchandise/search/brands']['get']['responses']['200']['content']['application/json']

async function getMerchandiseBrandsList(filters: App.MerchandiseBrandFilters): Promise<Array<string>> {
  const query = qs.stringify({
    name: filters.name || undefined,
    sortBy: filters.sortBy || undefined,
    categoryIds: filters.categories?.length ? filters.categories : undefined,
    limit: filters.limit || undefined,
  }, { arrayFormat: 'comma' })

  return requestUtils.get<Response>(`/api/merchandise/search/brands?${query}`).then((response) => {
    return response.result.brandIds
  })
}

export default getMerchandiseBrandsList
